<template>
  <div>
    <div class="headline primary--text">จำนวนการ Voucher ตามจังหวัด</div>
    <v-layout row wrap justify-end class="ma-0 pa-0">
      <!-- <v-flex xs6>
        <div class="headline primary--text my-0">Voucher report</div>
      </v-flex> -->
      <v-flex xs6 class="text-xs-right">
        <v-btn @click="exportData" :loading="loading" color="grey" outline>
          <i class="fas fa-file-export"></i>
          &nbsp;
          {{ $t('export') }}&nbsp;
        </v-btn>
        <exportxlsx ref="exbtn" :value="exData" style="display:none"></exportxlsx>
        <!-- <exportxlsx v-model="exportDataVoucher"></exportxlsx> -->
      </v-flex>
    </v-layout>
    <v-layout class="mb-0" row wrap justify-end>
      <v-flex class="form-control pa-1">
        <multiselect
          class="mr-0 mr-sm-2"
          @input="searchinput"
          v-model="selectProvince"
          :options="province"
          placeholder="จังหวัด"
          :searchable="true"
          deselect-label
        ></multiselect>
      </v-flex>
    </v-layout>

    <div>
      <v-pagination
        v-if="pageCount"
        @input="changepage"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        hide-actions
        :headers="headers"
        :items="showData"
        :pagination.sync="pagination"
        item-key="name"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td class="text-xs-center">
              {{ props.index + 1 }}
            </td>
            <td class="text-xs-center">
              {{ props.item.province || '-' }}
            </td>
            <td class="text-xs-center">
              {{ props.item.request }}
            </td>
            <td class="text-xs-center">
              {{ props.item.pending }}
            </td>
            <td class="text-xs-center">
              {{ props.item.approve }}
            </td>
            <td class="text-xs-center">
              {{ props.item.reject }}
            </td>
            <td class="text-xs-center">
              {{ props.item.expire }}
            </td>
            <td class="text-xs-center">
              {{ props.item.cancel }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import api from '@/api'
import config from '@/config'
import province from '@/assets/js/province'
import exportxlsx from '@/components/elements/exportxlsx.vue'

export default {
  components: {
    Multiselect,
    datepicker,
    exportxlsx
  },
  data() {
    return {
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 200
      },
      rowsPerPage: 200,
      exData: [],
      exDataAll: [],
      page: 1,
      loading: false,
      mainData: [],
      showData: [],
      topData: [],
      top5: [],
      topOther: [],
      tafficReport: {},
      topProduct: [],
      selectProvince: null,
      headers: [
        { text: 'ลำดับ', align: 'center', value: 'id' },
        { text: 'ชื่อจังหวัด', align: 'center', value: 'campaign' },
        { text: 'จำนวนการขอ Voucher', align: 'center', value: 'agency' },
        { text: 'รอตรวจสอบ', align: 'center', value: 'approve' },
        { text: 'อนุมัติแล้ว', align: 'center', value: 'buyer' },
        { text: 'ไม่อนุมัติ', align: 'center', value: 'reject' },
        { text: 'หมดอายุ', align: 'center', value: 'expire' },
        { text: 'ยกเลิก', align: 'center', value: 'cancel' }
      ]
    }
  },
  computed: {
    province() {
      return province
    },
    techhuntUrl() {
      return config.techhuntUrl
    },
    pageCount() {
      if (this.showData && this.showData[0] && this.showData[0].total) {
        let count = Math.ceil(this.showData[0].total / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    searchinput() {
      this.getCouponReport()
    },
    async getExData() {
      // this.data = await api.getProvinceCouponStat({})
      // this.exDataAll = this.data ? this.data : []
      this.exDataAll = this.showData
    },
    async getCampaign() {
      this.campaign = await api.getCampaign()
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      await this.setEx()
      this.$refs.exbtn.exportxlsx()
      this.loading = false
    },
    async changepage() {
      this.loading = true
      await this.getCouponReport()
      this.loading = false
    },
    shotDate(input) {
      return moment(input).format('DD/MM/YYYY')
    },
    async setup() {
      await this.getCouponReport()
      this.getCampaign()
    },
    async getCouponReport() {
      let params = {}
      params.limit = this.limitCom
      params.offset = this.offsetCom
      console.log(this.selectProvince)
      if (this.selectProvince) {
        params.province = this.selectProvince
      }
      // let agencylist = this.agencyOptions.map(agency => {
      //   return agency.name
      // })
      // agencylist = agencylist.join(',')
      // params.agencylist = agencylist
      this.loading = true
      this.data = await api.getProvinceCouponStat(params)
      this.loading = false
      this.showData = this.data ? this.data : []
    },
    clickDetail(id) {
      window.open(`${config.techhuntUrl}product?id=${id}`)
    },
    setEx() {
      let ex = []
      this.exDataAll.forEach(ele => {
        let obj = {
          ชื่อจังหวัด: ele.province,
          'จำนวนการขอ Voucher': ele.request,
          อนุมัติแล้ว: ele.approve,
          รอตรวจสอบ: ele.pending,
          ยกเลิก: ele.cancel
        }
        ex.push(obj)
      })
      this.exData = ex
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 120px;
  min-height: 60px;
  background-color: #182748;
  color: white;
  text-align: center;
  align-self: center;
  font-weight: bold;
}
.flex-row-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/view/voucherreport/byprovince.vue